import React from 'react';
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';

const s = {
  amount: { marginTop: 10 },
  amountText: { margin: 0, color: '#000' },
  amountValue: { margin: 0, color: '#999' },
};

class DiscountArea extends React.PureComponent {
  render() {
    const { contract, currencySymbol } = this.props;

    if (contract && contract.discountAmount) {
      let amount = CurrencyHelpers.centsToDollars(contract.discountAmount, { symbol: currencySymbol });

      return (
        <div>
          <h3>DISCOUNT:</h3>
          <div style={s.amount}>
            <p style={s.amountText}>
              Amount: <span style={s.amountValue}> {amount} </span>
            </p>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default DiscountArea;



// WEBPACK FOOTER //
// ./src/components/common/ContractComponent/ServicesAndPayment/DiscountArea/index.js